import FloatingVue from 'floating-vue';

export default defineNuxtPlugin(() => {
  FloatingVue.options.themes.tooltip.distance = 10;
  return;
});
